import type { Track } from '@typings/analytics';
import type { Dispatch } from '@typings/redux';
import { formatSavedVendorData } from '@utils/formatSavedVendorData';
import savedVendors from '@utils/savedVendors';
import { useCallback } from 'react';
import {
	fillFavoriteHeart,
	setSavedVendorId,
} from '../../favorites_button/actions';
import { useTrackAddToFavorites } from './use-track-add-to-favorites';

export const useCreateFavorite = (
	vendor: Vendor.Decorated,
	sessionToken: string | null,
	track: Track,
	dispatch: Dispatch,
) => {
	const trackAddToFavorites = useTrackAddToFavorites(vendor, track);

	return useCallback(
		async (weddingId?: string) => {
			return savedVendors
				.create({
					sessionToken,
					weddingId,
					data: formatSavedVendorData(vendor),
				})
				.then((response) => {
					if (response.errors || !response.saved_vendor) {
						return;
					}

					dispatch(fillFavoriteHeart());
					trackAddToFavorites();
					dispatch(setSavedVendorId(response.saved_vendor.id));
				});
		},
		[vendor, sessionToken, trackAddToFavorites, dispatch],
	);
};
